import type NodeDescriptor from "../models/NodeDescriptor";

const STORAGE_KEY = "automations:recent-nodes";
const MAX_RECENT = 6;

/** Stable identity of a palette entry: integration nodes share nodeType, so providerId wins. */
export function descriptorKey(descriptor: NodeDescriptor): string {
  return descriptor.providerId ?? descriptor.nodeType;
}

/** Keys of recently used nodes, most recent first. Persisted per-browser in localStorage. */
export function readRecentNodeKeys(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((k): k is string => typeof k === "string") : [];
  } catch {
    return [];
  }
}

export function recordRecentNode(descriptor: NodeDescriptor): void {
  const key = descriptorKey(descriptor);
  const keys = [key, ...readRecentNodeKeys().filter((k) => k !== key)].slice(0, MAX_RECENT);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(keys));
}
